<template>
  <div class="login-wrap">
    <div class="login-box">
      <div class="step-1">
        <div class="login-logo">
          <!-- <img src="../assets/logo-2.png" alt="logo"  style="width: 61px;height: 30px;"/> -->
          <div class="title">一体机订单管理后台</div>
        </div>
        <a-form-model ref="ruleForm" :model="ruleForm" :rules="rules">
          <a-form-model-item class="input-item" prop="userName">
            <a-input size="large" v-model="ruleForm.userName" placeholder="用户名">
              <a-icon slot="prefix" type="user" />
            </a-input>
          </a-form-model-item>
          <a-form-model-item class="input-item" prop="passWord">
            <a-input-password
              size="large"
              placeholder="密码"
              v-model="ruleForm.passWord"
              type="password"
            >
              <a-icon slot="prefix" type="lock" />
            </a-input-password>
          </a-form-model-item>
          <a-form-model-item>
            <a-button
              class="login"
              size="large"
              type="primary"
              html-type="submit"
              block
              @click="handleLogin"
            >登录
            </a-button>
          </a-form-model-item>
        </a-form-model>
      </div>
    </div>
  </div>
</template>

<script>
import { login, chooseCid } from '@/api'
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'HomeView',

  data () {
    const checkSpace = (rule, value, callback) => {
      if (/^ | $/.test(value)) {
        callback(new Error('禁止输入空格'))
      } else {
        callback()
      }
    }
    return {
      ruleForm: {
        userName: '',
        passWord: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户名！', trigger: ['blur', 'change'] },
          {
            validator: checkSpace,
            trigger: ['blur', 'change']
          }
        ],
        passWord: [
          { required: true, message: '请输入密码！', trigger: ['blur', 'change'] },
          {
            validator: checkSpace,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
    ...mapMutations(['SET_LOGIN_USER']),
    handleLogin (code) {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          try {
            login({
              username: this.ruleForm.userName,
              password: this.ruleForm.passWord
            }).then(res => {
              if(!res.cids || res.cids.length === 0) {
                this.$message.warning('该用户没有权限，请联系管理员')
                return
              } else {
                let loginUser = res
                this.SET_LOGIN_USER(loginUser)
                this.$router.push('/')
              }
            })
          } finally {
            console.log(1)
          }
        }
      })
    },
  }
}
</script>

<style lang="less" scoped>

.login-wrap {
  min-width: 650px;
  height: 100vh;
  background-color: #f5f5f7;
  .login-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    border-radius: 4px;
    .step-1 {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 368px;
      .login-logo {
        padding-bottom: 40px;
        text-align: center;
        img {
          height: 120px;
          margin-bottom: 10px;
        }
      }
      .login {
        background: #414042;
        border-radius: 4px;
      }
      .title {
        font-size: 18px;
        line-height: 1;
        font-weight: bold;
        text-align: center;
        margin-top: 8px;
      }
    }
  }
  /deep/ .input-item {
    .ant-input {
      width: 360px;
      &:-webkit-autofill {
        box-shadow: 0 0 0px 1000px white inset !important;
      }
    }
  }
  .save-password-item {
    /deep/ .ant-form-item-control {
      line-height: 1;
    }
  }
}

.login-box {
  display: flex;
  align-items: center;
}

.login-wrap .login-box {
  /deep/ .ant-form-explain {
    margin-top: 8px;
    text-align: left;
    &::before {
      content: 'x';
      height: 14px;
      width: 14px;
      background: #e33d2d;
      display: inline-block;
      color: white;
      border-radius: 50%;
      line-height: 15px;
      text-align: center;
      margin-right: 6px;
    }
  }
  /* 隐藏显示密码控件 */
  /deep/ .ant-input-password-icon {
    display: none;
  }
}

.login-customers {
  // position: absolute;
  // padding: 40px;
  // left: 0;
  // top: 0;
  // right: 0;
  // bottom: 0;
  // background-color: #fff;
  // z-index: 999;
  &-title {
    font-size: 14px;
    color: #000;
    font-weight: 400;
    margin-bottom: 16px;
  }
  /deep/ .ant-input {
    height: 36px;
    border-radius: 4px !important;
  }
  .query-input {
    margin-bottom: 16px;
    /deep/ .ant-input {
      background: #fff;
    }
  }
  .login-users-btn {
    .ant-btn {
      width: 360px;
      height: 40px;
      background: #414042;
      border: 1px solid #414042;
      border-radius: 4px;
    }
    .link {
      margin-top: 16px;
      text-align: center;
      color: #2185f9;
      cursor: pointer;
    }
  }
  .customs {
    width: 360px;
    height: 192px;
    overflow: auto;
    line-height: 24px;

    background: #fff;
    margin-bottom: 16px;
    .cus-empty {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 48px;
    }
    li {
      cursor: pointer;
      user-select: none;
      font-size: 14px;
      line-height: 36px;
      padding: 0 12px;
      .anticon {
        display: none;
        float: right;
        line-height: 36px;
        font-size: 16px;
      }
      &:hover {
        background-color: #fafaf8;
      }
      &.active {
        color: #f96a57;
        .anticon {
          display: block;
        }
      }
    }
  }
}
</style>
